<router-outlet></router-outlet>

<app-confirm-dialog></app-confirm-dialog>  

<app-my-loader></app-my-loader>